export default __webpack_public_path__ + "static/media/pp-188-cn.741af539.png";